import Api from './Api';

const END_POINT = 'comisiones'

export default {
    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(comision) {
        return await Api.post(`${END_POINT}`, comision)
    },
    async update(comision) {
        return await Api.patch(`${END_POINT}/${comision.id}`, comision)
    },
    async change_status(comision) {
        return await Api.patch(`${END_POINT}/${comision.id}/change-status`, comision)
    },
    async change_pagar(form) {
        return await Api.patch(`${END_POINT}/${form.id}/change-pagar`, form)
    },
    async delete(comision) {
        return await Api.delete(`${END_POINT}/${comision.id}`, comision)
    },
    async get_excel_for_comissions(filters = null){
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}/comissions-export`, request)
    }
}